import { Icons } from '@pankod/refine-antd'
import { ResourceProps } from '@pankod/refine-core'

import { PPGSyncProgressList } from './ppg-sync-progress/list'
import { AlterProgramParticipantsList } from './alter-program-participants/list'
import { AlterProgramParticipantsEdit } from './alter-program-participants/edit'
import { GenerateLTIConfigList } from '@resources/ops-toolkit/generate-lti-config/list'

export const opsToolkitManagementResource: ResourceProps[] = [
  {
    name: 'ops-toolkit',
    icon: <Icons.SettingOutlined />,
    options: {
      label: 'Ops Toolkit',
      route: 'ops-toolkit',
    },
  },
  {
    name: 'alter-program-participants',
    parentName: 'ops-toolkit',
    options: {
      label: 'Alter Program & Participants',
      route: 'alter-program-participants',
    },
    list: AlterProgramParticipantsList,
    edit: AlterProgramParticipantsEdit,
  },
  {
    name: 'generate-lti-config',
    parentName: 'ops-toolkit',
    options: {
      label: 'Generate LTI Configuration',
      route: 'generate-lti-config',
    },
    list: GenerateLTIConfigList,
  },
  {
    name: 'ppg-sync-progress',
    parentName: 'ops-toolkit',
    options: {
      label: 'PPG Sync Progress',
      route: 'ppg-sync-progress',
    },
    list: PPGSyncProgressList,
  },
]
